import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class PrimaWarningValue extends Model {
  [Type] = 'prima-warning-value' as const;

  @attr('number') declare dayOfWeek: number;
  @attr('number') declare maxMinPriceDiff: number;
}
